
import React, { useEffect, useState } from 'react';
import DietCard from '../components/DietCard';
import { fetchWithCSRF } from '../utils/csrfUtils';
import { Spinner } from 'react-bootstrap';

const DietCardsSelector = ({ sessionToken, onDietClick }) => {
    const [diets, setDiets] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // Second useEffect for API calls that need the session token
    useEffect(() => {
        if (!sessionToken) return;

        const fetchDiets = async () => {
            try {
                const response = await fetchWithCSRF('/api/v1/diet', {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${sessionToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error(`Failed to fetch diets: ${response.status}`);
                }

                const data = await response.json();
                
                // Validate the response data
                if (!Array.isArray(data)) {
                    throw new Error('Invalid data format: expected an array of diets');
                }

                setDiets(data);
                setError(null);
            } catch (error) {
                console.error('Error fetching diets:', error);
                setError('Failed to load diet options');
            } finally {
                setIsLoading(false);
            }
        };

        fetchDiets();
    }, [sessionToken]);

    if (isLoading) {
        return (
            <div className="text-center my-4">
                <Spinner animation="border" role="status" style={{ color: '#52cd92' }}>
                    <span className="visually-hidden">Loading diets...</span>
                </Spinner>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-warning" role="alert">
                <p className="mb-0">{error}</p>
            </div>
        );
    }

    if (!diets.length) {
        return (
            <div className="alert alert-info" role="alert">
                <p className="mb-0">No diet options available at the moment.</p>
            </div>
        );
    }

    return (
        <div className="diet-cards">
            <div className="diet-card-container">
                {diets.map(diet => (
                    <DietCard key={diet.id} diet={diet} onClick={onDietClick} />
                ))}
            </div>
        </div>
    );
};

export default DietCardsSelector;
